export const getScenes = state => state.scenes.scenes
